/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';

export class payer_index extends IceEntity {
  payer_index_key: string = "";
  trans_account: string = "";
  organization_name: string = "";
  city: string = "";
  state_id: string = "";
  postal_code: string = "";
  identification_code1: string = "";
  identification_code2: string = "";
  identification_code3: string = "";
  additional_name: string = "";

  constructor() {
    super();
  }

  gettablename(): string {
    return "PAYER_INDEX";
  }

  getdisplayname(organization: boolean): string {
    return this.organization_name;
  }
}
